import { DestroyRef, Directive, ElementRef, Input } from '@angular/core';
import { PolicySetKey } from 'src/shared/constants';
import { UserPolicyEvalDto } from 'src/shared/services/api.service';
import { LocalStorageService } from 'src/shared/services/local-storage.service';

@Directive({
  selector: '[requiresPolicy]',
  standalone: false,
})
export class RequiresPolicyDirective {
  private maxRetries = 5;
  private delay = 500;
  private attempts = 0;
  private timeoutId: ReturnType<typeof setTimeout> | undefined;

  constructor(
    private readonly el: ElementRef,
    private readonly localStorageService: LocalStorageService,
    destroyRef: DestroyRef,
  ) {
    destroyRef.onDestroy(() => clearTimeout(this.timeoutId));
  }

  @Input() set requiresPolicy(policyName: keyof UserPolicyEvalDto) {
    this.checkPolicy(policyName);
  }

  private checkPolicy(policyName: keyof UserPolicyEvalDto) {
    const policySet = JSON.parse(this.localStorageService.get(PolicySetKey) ?? '{}') as UserPolicyEvalDto;

    if (policySet && this.hasAtLeastOneValue(policySet)) {
      const result = policySet[policyName];
      // ng-container renders as a comment node — comment nodes have no .style
      if (result !== true && this.el.nativeElement?.style) {
        this.el.nativeElement.style.display = 'none';
      }
    } else if (this.attempts < this.maxRetries) {
      this.attempts++;
      this.timeoutId = setTimeout(() => this.checkPolicy(policyName), this.delay);
    } else {
      console.warn(`Max retries reached for checking policy ${policyName}`);
    }
  }

  private hasAtLeastOneValue(policySet: UserPolicyEvalDto): boolean {
    return Object.values(policySet).some((value) => value !== undefined);
  }
}
